<user-ingot [user]="user" [link]="user | k2UserLink"></user-ingot>
